import { Loader, Select as MantineSelect, SelectProps } from "@mantine/core";
import get from "lodash/get";
import { useMemo } from "react";

interface Props extends SelectProps {
  loading?: boolean;
}

const iconPropsMap = {
  s: { inputPaddingLeft: "20px", iconSize: 15, iconWidth: 20 },
  m: { inputPaddingLeft: "25px", iconSize: 15, iconWidth: 20 },
};

export const Select = ({ loading = false, ...props }: Props) => {
  const iconProps = useMemo(() => {
    return get(iconPropsMap, props.size ?? "s", iconPropsMap.s);
  }, [props.size]);

  return (
    <MantineSelect
      styles={{
        input: {
          paddingLeft: loading ? iconProps.inputPaddingLeft : undefined,
        },
      }}
      icon={
        loading ? (
          <Loader size={iconProps.iconSize} style={{ marginLeft: "5px" }} />
        ) : undefined
      }
      iconWidth={iconProps.iconWidth}
      size={props.size}
      disabled={loading || props.disabled}
      nothingFound="No results found"
      {...props}
    />
  );
};
